









import { Component, Vue } from 'vue-property-decorator'

import 'semantic-ui-css/components/container.min.css'
import 'semantic-ui-css/components/segment.min.css'
import 'semantic-ui-css/components/grid.min.css'

import Projects from '@/data/projects'
import Project from '@/comps/Project.vue'

@Component({ components: { Project } })
export default class LCProjects extends Vue {
  prjs = Projects
}
